import {ProductSummaryModel} from './productSummary.model';

export class ProductModel {

    summary: ProductSummaryModel;
    comment: string;
    shippable: boolean;
}

export enum PRODUCT_TYPE {
    PRODUCT_TYPE_PURCHASE = 'PRODUCT_TYPE_PURCHASE',
    PRODUCT_TYPE_SALE = 'PRODUCT_TYPE_SALE'
}
